import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsivePicture',
  props: {
    srcMobile: null,
    srcDesktop: null,
    alt: {
      default: ''
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'ResponsivePicture'
    });
    return {
      __sfc: true
    };
  }
});